



























































































import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { draggableDelay } from '@/web/utils/draggable';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    data: {
      type: Object as () => QuizQuestionResponse,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    settings: {
      type: Array,
      default() {
        return [];
      },
    },
    showManualCheck: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      draggableDelay,
      form: {} as QuizQuestionResponse,
    };
  },
  methods: {
    async save() {
      try {
        const data = { ...this.form };
        if (data.answers?.[0]?.answer_type === 'scale') {
          await this.$store.dispatch('quiz/updateQuizAnswer', {
            quizId: this.data.quiz,
            questioId: this.data.id,
            data: data.answers[0],
          });
        }

        const question = await this.$store.dispatch('quiz/updateQuizQuestion', {
          quizId: this.data.quiz,
          data,
        });
        this.$store.dispatch('quiz/refreshQuizQuestion', question);
        this.form = { ...question };
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_UPDATE_QUIZ_QUESTION'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$refs.form?.reset();
      }
    },
  },
  computed: {
    rangeOptions() {
      return [3, 4, 5, 6, 7, 8, 9];
    },
  },
  watch: {
    'data.id': {
      handler() {
        this.form = { ...this.data };
      },
      immediate: true,
    },
  },
});
